import momentEU from 'moment/locale/eu'
import enUS from 'ant-design-vue/es/locale/en_US'
import global from './en-US/global'

import menu from './en-US/menu'
import setting from './en-US/setting'
import user from './en-US/user'

import dashboard from './en-US/dashboard'
import form from './en-US/form'
import result from './en-US/result'
import account from './en-US/account'

const components = {
  antLocale: enUS,
  momentName: 'eu',
  momentLocale: momentEU
}

export default {
  message: '-',

  'layouts.usermenu.dialog.title': '提示',
  'layouts.usermenu.dialog.content': '确定要退出登录吗?',
  'layouts.userLayout.title': 'MetaWorksPlatform 是凌云光最具影响力的数字人展示平台',
  ...components,
  ...global,
  ...menu,
  ...setting,
  ...user,
  ...dashboard,
  ...form,
  ...result,
  ...account
}
